(() => {
  if (window.CQZMobilePerformanceReady) return;
  window.CQZMobilePerformanceReady = true;

  const mobileQuery = window.matchMedia('(max-width: 767px)');
  const isMobile = () => mobileQuery.matches;
  const isHome = () => document.body && document.body.classList.contains('hdt-page-type-index');

  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const optimizeImages = () => {
    const images = Array.from(document.images || []);
    if (!images.length) return;

    const firstHeroImage = images.find((image) => {
      const src = image.currentSrc || image.src || '';
      return src.includes('cqz-hero-slide-') || image.closest('.hdt-section-hero-image, .cqz-affiches-section');
    });

    if (firstHeroImage) {
      firstHeroImage.loading = 'eager';
      firstHeroImage.decoding = 'async';
      firstHeroImage.setAttribute('fetchpriority', 'high');
    }

    images.forEach((image) => {
      if (image === firstHeroImage) return;
      image.decoding = 'async';
      if (!image.closest('.hdt-section-hero-image, .cqz-affiches-section')) {
        image.loading = 'lazy';
        image.setAttribute('fetchpriority', 'low');
      }
    });
  };

  const deferExtraMobileHeroSlides = () => {
    const hero = document.querySelector('.cqz-affiches');
    if (!hero) return;
    const slides = [...hero.querySelectorAll('.cqz-affiche')].sort((a,b)=>parseFloat(a.style.getPropertyValue('--delai-mobile'))-parseFloat(b.style.getPropertyValue('--delai-mobile')));
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;
    let timer;
    let generation = 0;
    const ready = async (slide) => {
      const img = slide.querySelector('img');
      img.loading = 'eager';
      img.setAttribute('fetchpriority', slide === slides[0] ? 'high' : 'low');
      slide.querySelectorAll('source[data-cqz-srcset]').forEach(source => {
        source.srcset = source.dataset.cqzSrcset;
        source.removeAttribute('data-cqz-srcset');
      });
      try {
        await img.decode();
        return img.naturalWidth > 1;
      } catch { return false; }
    };
    const cycle = () => {
      if (!isMobile() || reduceMotion.matches || document.hidden) return;
      const token = generation;
      timer = window.setTimeout(async () => {
        const next = (current + 1) % slides.length;
        const prepared = ready(slides[next]);
        timer = window.setTimeout(async () => {
          const loaded = await prepared;
          if (token !== generation) return;
          if (loaded) {
            const previous = slides[current];
            slides[next].classList.add('cqz-hero-active');
            slides[next].classList.remove('cqz-hero-previous');
            previous.classList.add('cqz-hero-previous');
            previous.classList.remove('cqz-hero-active');
            current = next;
            window.setTimeout(() => previous.classList.remove('cqz-hero-previous'), 450);
          }
          cycle();
        }, 1200);
      }, 3800);
    };
    const restart = async () => {
      generation++;
      clearTimeout(timer);
      slides.forEach((slide, i) => {
        slide.classList.toggle('cqz-hero-active', i === current);
        slide.classList.remove('cqz-hero-previous');
      });
      if (isMobile() && !document.hidden && await ready(slides[current])) cycle();
    };
    mobileQuery.addEventListener('change', restart);
    reduceMotion.addEventListener('change', restart);
    document.addEventListener('visibilitychange', restart);
    restart();
  };

  onReady(() => {
    if (!isHome()) return;
    deferExtraMobileHeroSlides();
    if (isMobile()) optimizeImages();
  });
})();
